module.exports = __webpack_public_path__ + "img/356-285eaa.png";